/**
 * Lightweight merchant display helpers for business expense exports.
 */

export function businessMerchantKey(description: string, merchantName?: string | null): string {
  const raw = (merchantName?.trim() || description).trim();
  return normaliseBusinessMerchantName(raw || description);
}

/** Normalise common bank description prefixes to a short vendor label. */
export function normaliseBusinessMerchantName(description: string): string {
  const upper = description.toUpperCase();
  if (upper.includes('OPENAI') || upper.includes('CHATGPT')) return 'OpenAI / ChatGPT';
  if (upper.includes('CLAUDE') || upper.includes('ANTHROPIC')) return 'Anthropic / Claude';
  if (upper.includes('CURSOR')) return 'Cursor';
  if (upper.includes('FIGMA')) return 'Figma';
  if (upper.includes('GOOGLE *GOOGLE ONE') || upper.includes('GOOGLE ONE')) return 'Google One';
  if (upper.includes('MIRO')) return 'Miro';
  if (upper.includes('LUMEN5')) return 'Lumen5';
  if (upper.includes('PERPLEXITY')) return 'Perplexity';
  if (upper.includes('READDY')) return 'Readdy AI';
  if (upper.includes('REPLIT')) return 'Replit';
  if (upper.includes('HOSTINGER')) return 'Hostinger';
  if (upper.includes('OFFICEWORKS')) return 'Officeworks';
  const first = description.split(/\s+/).slice(0, 3).join(' ').trim();
  return first || description;
}

/** Fix known category display typos in exports (seed data may lag). */
export function sanitiseBusinessCategoryDisplayName(name: string): string {
  return name
    .replace(/ChatGBT/gi, 'ChatGPT')
    .replace(/Cloud Hosting \(AWS\/Azure\/GCP\)/i, 'Web & cloud hosting');
}
